import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Stack } from "@mui/material";
import DataTableLayout from "layouts/DatatableLayout";
import DataSyncControl from "layouts/DataSyncControl";
import { syncBrand } from "../../redux/handlers/syncdata/syncBrand.handler";
import { ModalAllder } from "layouts/ModalAllder";
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { allBrand } from "../../redux/handlers/manage/allBrand.handler";
import { createBrand, clearcreateBrand } from "../../redux/handlers/manage/createBrand.handler";
import { updateBrand, clearupdateBrand } from "../../redux/handlers/manage/updateBrand.handler";
import { deleteBrand, cleardeleteBrand } from "../../redux/handlers/manage/deleteBrand.handler";
export function Brand() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), modelText = _useState1[0], setmodelText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState6[0], setModal = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState7[0], setModalDel = _useState7[1];
    var allBrandReducer = useAppSelector(function(state) {
        return state.allBrandReducer;
    });
    useEffect(function() {
        dispatch(allBrand(null, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(allBrandReducer.isFetching);
        if (allBrandReducer.data) {
            var data = allBrandReducer.data.data;
            setRowData(data);
            setFilteredItems(data);
        }
    }, [
        allBrandReducer
    ]);
    useEffect(function() {
        if (filterText) {
            setRowData(filteredItems.filter(function(item) {
                return [
                    item.set_brand_name,
                    item.set_brand_nameen,
                    item.set_brand_namela
                ].filter(Boolean).some(function(value) {
                    return value.toLowerCase().includes(filterText.toLowerCase());
                });
            }));
        } else {
            setRowData(filteredItems);
        }
    }, [
        filteredItems,
        filterText
    ]);
    var columns = [
        {
            name: "ชื่อแบนรด์ภาษาไทย",
            selector: function(row) {
                return row.set_brand_name || "-";
            },
            center: "true"
        },
        {
            name: "ชื่อแบรนด์ภาษาอังกฤษ",
            selector: function(row) {
                return row.set_brand_nameen || "-";
            },
            center: "true"
        },
        {
            name: "ชื่อแบนรด์ภาษาลาว",
            selector: function(row) {
                return row.set_brand_namela || "-";
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.set_brand_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return row.set_brand_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ใช้งาน"
                }) || row.set_brand_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่ใช้งาน"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.set_brand_id;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "editBrand",
                                        data: {
                                            id: row.set_brand_id,
                                            name: row.set_brand_name,
                                            nameen: row.set_brand_nameen,
                                            namela: row.set_brand_namela,
                                            status: row.set_brand_status
                                        }
                                    });
                                });
                                setmodelText("แก้ไขแบรนด์");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "deleteBrand",
                                        data: {
                                            id: row.set_brand_id,
                                            name: row.set_brand_name,
                                            namela: row.set_brand_namela
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบแบรนด์");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataSyncControl, {
                            syncStatus: row.set_brand_syncstatus,
                            rowData: row,
                            syncHandler: syncBrand,
                            syncPayload: function(data) {
                                return {
                                    brandid: data.set_brand_id
                                };
                            },
                            syncHandlerOptions: {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            },
                            onSyncSuccess: function() {
                                return dispatch(allBrand(null, {
                                    modalObj: modalObj,
                                    setModalObj: setModalObj
                                }));
                            }
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการแบรนด์"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "จัดการแบรนด์"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 7
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 5,
                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                            direction: "horizontal",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control me-3",
                                                    placeholder: "ค้นหารายการ",
                                                    onKeyUp: function(e) {
                                                        return setFilterText(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn btn-dg ml-2 w-[250px] fs-14",
                                                    onClick: function() {
                                                        setModal(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: true,
                                                                typeData: "createBrand",
                                                                data: null
                                                            });
                                                        });
                                                        setmodelText("สร้างแบรนด์");
                                                    },
                                                    children: "สร้างแบรนด์"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(BrandModel, {
                    setModal: setModal,
                    modal: modal,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function BrandModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), name = _useState[0], setName = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), nameen = _useState1[0], setNameen = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), namela = _useState2[0], setNamela = _useState2[1];
    var _useState3 = _sliced_to_array(useState(1), 2), type = _useState3[0], setType = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), id = _useState4[0], setId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), textErr = _useState5[0], setTextErr = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), textErrLa = _useState6[0], setTextErrLa = _useState6[1];
    var createBrandReducer = useAppSelector(function(state) {
        return state.createBrandReducer;
    });
    var updateBrandReducer = useAppSelector(function(state) {
        return state.updateBrandReducer;
    });
    useEffect(function() {
        if (modal.data == null) {
            setName("");
            setNameen("");
            setNamela("");
            setType(1);
            setId(0);
            setTextErr("");
            setTextErrLa("");
        }
        if (modal.data != null) {
            var vul = modal.data;
            setName(vul.name);
            setNameen(vul.nameen || "");
            setNamela(vul.namela);
            setType(vul.status);
            setId(vul.id);
            setTextErr("");
            setTextErrLa("");
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        setIsLoading(createBrandReducer.isFetching || updateBrandReducer.isFetching);
        if (createBrandReducer.data && !createBrandReducer.isError) {
            setTextsuccess("สร้างแบนรด์สำเร็จ");
            setModalsuccess(true);
            dispatch(clearcreateBrand());
            dispatch(allBrand(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setNameen("");
            setNamela("");
            setType(1);
            setId(0);
            setTextErr("");
            setTextErrLa("");
        }
        if (updateBrandReducer.data && !updateBrandReducer.isError) {
            setTextsuccess("แก้ไขแบนรด์สำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateBrand());
            dispatch(allBrand(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setNameen("");
            setNamela("");
            setType(1);
            setId(0);
            setTextErr("");
            setTextErrLa("");
        }
    }, [
        createBrandReducer,
        updateBrandReducer
    ]);
    var onClickModel = function() {
        if (modal.typeData == "createBrand") {
            setTextErr("");
            setTextErrLa("");
            if (!name) {
                setTextErr("กรุณากรอกชื่อแบรนด์ภาษาไทย");
            } else if (!namela) {
                setTextErrLa("กรุณากรอกชื่อแบรนด์ภาษาลาว");
            } else {
                var data = {
                    set_brand_name: name,
                    set_brand_nameen: nameen,
                    set_brand_namela: namela,
                    set_brand_status: type
                };
                dispatch(createBrand(data, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        } else if (modal.typeData == "editBrand") {
            setTextErr("");
            setTextErrLa("");
            if (!name) {
                setTextErr("กรุณากรอกชื่อแบรนด์");
            } else if (!namela) {
                setTextErrLa("กรุณากรอกชื่อแบรนด์ภาษาลาว");
            } else {
                var data1 = {
                    set_brand_id: id,
                    set_brand_name: name,
                    set_brand_nameen: nameen,
                    set_brand_namela: namela,
                    set_brand_status: type
                };
                dispatch(updateBrand(data1, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        }
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อแบนรด์ภาษาไทย",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(textErr ? "is-invalid" : ""),
                                placeholder: "ชื่อแบนรด์ภาษาไทย",
                                value: name,
                                onChange: function(e) {
                                    setName(e.target.value);
                                    if (textErr) {
                                        setTextErr("");
                                    }
                                }
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsx(Form.Label, {
                                className: "mb-1",
                                children: "ชื่อแบรนด์ภาษาอังกฤษ"
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control",
                                placeholder: "ชื่อแบรนด์ภาษาอังกฤษ",
                                value: nameen,
                                onChange: function(e) {
                                    setNameen(e.target.value);
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อแบนรด์ภาษาลาว",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(textErrLa ? "is-invalid" : ""),
                                placeholder: "ชื่อแบนรด์ภาษาลาว",
                                value: namela,
                                onChange: function(e) {
                                    setNamela(e.target.value);
                                    if (textErrLa) {
                                        setTextErrLa("");
                                    }
                                }
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErrLa
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsx(Form.Label, {
                        className: "mb-2  tc-10",
                        children: "สถานะ"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-1",
                                label: "เปิดใช้งาน",
                                checked: type == 1 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setType(1);
                                }
                            }),
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-2",
                                label: "ปิดใช้งาน",
                                checked: type == 2 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setType(2);
                                }
                            })
                        ]
                    }, "p-radio")
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "flex-end",
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 me-3 btn py-2 px-3 mt-4",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: false
                                        });
                                    });
                                },
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "mt-4 btn btn-dg w-400",
                                onClick: function(e) {
                                    onClickModel();
                                },
                                children: "บันทึก"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var deleteBrandReducer = useAppSelector(function(state) {
        return state.deleteBrandReducer;
    });
    useEffect(function() {
        setIsLoading(deleteBrandReducer.isFetching);
        if (deleteBrandReducer.data && !deleteBrandReducer.isError) {
            setTextsuccess("ลบแบรนด์สำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteBrand());
            dispatch(allBrand(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deleteBrandReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        if (modal.typeData == "deleteBrand") {
            var data = {
                brandid: parseInt(id)
            };
            dispatch(deleteBrand(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการลบข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
